import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {faPlus, faMinus} from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar"
import { IKImage } from "imagekitio-react";
import { Dialog } from "@headlessui/react";
import MskillComplete from "../Quiz/MskillComplete";
import { editOneDayChallenge } from "../../../redux/actions/userActivity";

const ContentPlayerAccordian = ({ title, children, id, progress, mskill

    // openUpgradeToPremium

}) => {
    const [isActive, setIsActive] = useState(false);
    const [showQuizPopup, setShowQuizPopup] = useState({ open: false })
    // const [mskillProgress, setMskillProgress] = useState(0)
    const { mskill_slug } = useParams()
    const {contentId} = useParams();
    const user_id = useSelector(store => store?.profileDetails?.id)
    const user_token = useSelector(store => store?.authentication?.user_token)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const user_extended_challenges = useSelector(store => store?.userActivity?.user_extended_challenges)

    useEffect(() => {
        if (id === mskill_slug) {
            setIsActive(true);
        }
    }, [contentId]);

    console.log('testing print' , isActive , id, mskill_slug);

    const handleAccordionChange = () => {
        // if (!mskill?.urp_is_locked) {
        setIsActive(!isActive);
        // }
        // else {
        //     openUpgradeToPremium()
        // }
    };

    useEffect(() => {

        // console.log({ mskill, progress })

        let data = user_extended_challenges?.findIndex(item => item?.mskill_slug === mskill_slug)

        if (data > -1) {
            if (progress == 100) {
                // let ans = user_extended_challenges.filter(item => item?.mskill_slug !== mskill_slug)
                // console.log({ ans })
                if (user_extended_challenges[data]?.expires_at > Date.now())
                    dispatch(editOneDayChallenge(user_extended_challenges[data]))
                // console.log(ans)
            }
        }
        // console.log(data)

    }, [progress])

    function getDuration(seconds) {
        // let time;
        if (seconds > 60) {
            if (seconds > 3600) {
                return `${(seconds / 3600).toFixed(1)} hours`
            }
            return `${(seconds / 60).toFixed(0)} Min`
        }
    }

    // console.log(id)

    console.log('progress tile bar' , progress);
    return (
        <div>
            <div
                className={`cursor-pointer font-bold flex justify-between items-center p-2 mt-2.5 rounded border-2 ${mskill?.progress < 100 ? id === mskill_slug ? "border-[#F39507]" : "border-[#DDDDDD]" : 'border-[#10A786]'}`}
                // className={`cursor-pointer ${mskill?.urp_is_locked ? "opacity-70" : ""} font-bold flex justify-between items-center p-2 mt-2.5 rounded border-2 ${!mskill?.urp_is_locked ? mskill?.progress < 100 ? id === mskill_slug ? "border-[#F39507]" : "border-[#DDDDDD]" : 'border-[#10A786]' : ""}`}
                onClick={handleAccordionChange}
                style={{ boxShadow: '0px 0px 27px rgba(0, 0, 0, 0.12)' }}
            >
                <div className="flex flex-col justify-between items-start w-[70%]">
                    <h1
                        className={`${mskill?.progress < 100 ? id === mskill_slug ? "text-[#F39507]" : "" : 'text-[#10A786]'} text-md md:text-sm`}
                    // className={`${!mskill?.urp_is_locked ? mskill?.progress < 100 ? id === mskill_slug ? "text-[#F39507]" : "" : 'text-[#10A786]' : ""} text-md md:text-sm`}
                    >{title}</h1>
                    <h2 className="text-xs text-gray-400 font-light mt-1">{mskill?.lessons_of_mskill?.length} Lessons • {getDuration(mskill?.mskill_duration)}</h2>
                </div>
                <div className={`flex ${mskill?.progress == 100 || id === mskill_slug ? "justify-between" : "justify-end"} items-center w-[30%]`}>
                    {
                        // !mskill?.urp_is_locked ? 
                        (mskill?.progress === 100 || id === mskill_slug) && <>
                            <div onClick={(e) => {
                                console.log("hi", showQuizPopup)
                                if (user_token) {
                                    e.stopPropagation();
                                    setShowQuizPopup(prev => ({ ...prev, open: true, mskill: mskill }))
                                }
                                else {
                                    navigate('/login')
                                }
                            }
                            }>
                                <img
                                    urlEndpoint="https://assets.learntube.ai/files/"
                                    src={`${mskill.progress < 100 ? "https://assets.learntube.ai/files/Content_player/certificateIcon.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657529938820" : "https://assets.learntube.ai/files/Content_player/certificateComplete.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657713625660"}`}
                                    className="w-7 h-7"
                                    transformation={[{
                                        "height": "60",
                                        "width": "60",
                                    }]}
                                />
                            </div>
                            <div className='w-9 h-9 md:w-8 md:h-8 font-bold'>
                                <CircularProgressbar value={mskill?.progress} text={`${mskill?.progress ? mskill?.progress : 0}%`} strokeWidth={9} styles={buildStyles({
                                    textSize: '30px',
                                    pathTransitionDuration: 0.5,
                                    // Colors
                                    pathColor: `${mskill?.progress < 100 ? "#F39507" : "#10A786"}`,
                                    textColor: `${mskill.progress < 100 ? "#F39507" : "#10A786"}`,
                                    trailColor: '#C7C7C7',
                                })}
                                />
                            </div>
                        </>
                        // :
                        // <div>
                        //     <FontAwesomeIcon icon={faLock} />
                        // </div>
                    }
                    {/* {!mskill?.urp_is_locked && <div className="cursor-pointer">{isActive ? <FontAwesomeIcon icon={faMinus} size="sm" className={`${mskill?.progress < 100 ? "text-[#F39507]" : "text-[#10A786]"}`} /> : <FontAwesomeIcon icon={faPlus} size="sm" className={`${mskill?.progress < 100 ? "text-[#F39507]" : "text-[#10A786]"}`} />}</div>} */}
                    <div className="cursor-pointer">{isActive ? <FontAwesomeIcon icon={faMinus} size="sm" className={`${mskill?.progress < 100 ? "text-[#F39507]" : "text-[#10A786]"}`} /> : <FontAwesomeIcon icon={faPlus} size="sm" className={`${mskill?.progress < 100 ? "text-[#F39507]" : "text-[#10A786]"}`} />}</div>
                </div>
            </div>
            {
                isActive &&
                <div className="border border-[#E5E5E5] rounded-b bg-white">{children}</div>
            }
            {
                (showQuizPopup.open && showQuizPopup?.mskill?.mskill_slug === mskill?.mskill_slug) &&
                <Dialog open={showQuizPopup.open}
                    onClose={() => setShowQuizPopup(prev => ({ ...prev, open: false }))}
                    as="div"
                    className="fixed inset-0 z-10 overflow-y-auto flex md:justify-start md:mt-28 w-full h-full justify-center flex-col items-center" >
                    <Dialog.Overlay className="fixed inset-0 bg-black opacity-70 z-10" />
                    <Dialog.Title />
                    <Dialog.Description />
                    <div className="bg-white z-20 w-[90%] md:w-1/3 absolute top-1/5 md:top-0 py-5 px-3 rounded-lg flex flex-col justify-center items-center">
                        <MskillComplete navigateTo={null} isContentPlayer={true} setShowQuizPopup={setShowQuizPopup} mskill={mskill} jesData={null} mskillData={null} mSkillProgress={progress}/>
                    </div>
                </Dialog>
            }
            {/* <UpgradeToPremium openModal={usePremiumModal} /> */}
        </div >
    );
};

export default ContentPlayerAccordian;
